module.exports = __webpack_public_path__ + "img/ic-email.8ad3ddf5.svg";